import {toISODateString} from '@lib/utils';
import getISOWeek from 'date-fns/getISOWeek';
import {CalendarDay} from '../types';

export const toCalendarDay = (date: Date): CalendarDay => ({
  date: toISODateString(date),
  weekNumber: getISOWeek(date),
});

export const toCalendarDays = (dates: Date[]): CalendarDay[] => dates.map(toCalendarDay);
